import { Component, computed, inject } from '@angular/core';
import { CdcSimpleHeaderComponent, CdcSimpleHeaderConfig } from 'cdc-conte-ui-kit';
import { DesignAngularKitModule } from 'design-angular-kit';
import { Auth } from '../../services/auth';
import { ProfileService } from '../../services/profile-service';
import { RouterServiceConte } from '../../services/router-service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CdcSimpleHeaderComponent, DesignAngularKitModule],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export default class Header {

  private readonly auth = inject(Auth);
  private readonly routerService = inject(RouterServiceConte);
  private readonly profileService = inject(ProfileService);

  private readonly baseConfig: CdcSimpleHeaderConfig = {
    id: 'mainHeader',
    title: 'Corte dei Conti',
    sticky: true,
    textColor: '#ffffff',

    brand: {
      logoSrc: 'img/brand/cortedeicontiLogo.svg',
      logoAlt: 'Corte dei Conti',
      wordmarkSrc: 'img/brand/conteLogo.svg',
      wordmarkAlt: 'ConTe - Contabilità Territoriale',
    },
  };

  header = computed<CdcSimpleHeaderConfig>(() => {
    const fullName = this.auth.userFullName();
    const profile = this.profileService.profileSelected();
    const role = profile?.codiRuolo;
    const ente = profile?.ente;
    
    return {
      ...this.baseConfig,
      user: fullName
        ? {
          fullName,
          role,
          ente,
          menu: [
            { label: 'Selezione profilo', action: 'selectProfile' },
            {
              label: 'GET',
              href: environment.GET_URL,
              target: '_blank',
              rel: 'noopener noreferrer',
            },
            {
              label: 'Fitnet',
              href: environment.FITNET_URL,
              target: '_blank',
              rel: 'noopener noreferrer',
            },
            {
              label: 'Servizi online',
              href: environment.SERVIZI_ONLINE_URL,
              target: '_blank',
              rel: 'noopener noreferrer',
            },
            { label: 'Logout', action: 'logout', iconName: 'logout' },
          ],
        }
        : undefined, 
    };
  });

  onUserAction(action: string) {
    if (action === 'logout') {
      this.auth.logout();
    } else if (action === 'selectProfile') {
      this.profileService.clearProfile();
      this.routerService.redirectTo('/profili');
    }
  }

  onBrandClick(e: Event) {
    e.preventDefault();
    if (this.profileService.hasProfileSelected()) {
      this.routerService.redirectTo('/home');
    }
  }
}
